import { Info } from 'lucide-react';

import React from 'react';

import { Label as LabelPrimitive } from '@/components/ui/label';

import { cn } from '@/lib/utils';

import { Tooltip } from './tooltip';

interface Props extends React.ComponentProps<typeof LabelPrimitive> {
	tooltip?: string;
}

function Label({ children, tooltip, ...props }: Props) {
	return (
		<LabelPrimitive
			{...props}
			className={cn(props.className, 'flex items-center gap-2 text-secondary')}
		>
			{children}
			{tooltip && (
				<Tooltip text={tooltip}>
					<Info className="size-4 shrink-0 text-secondary" />
				</Tooltip>
			)}
		</LabelPrimitive>
	);
}

export default Label;
